import { useCallback, useEffect, useRef, useState } from 'react';

const DEFAULT_EXIT_DURATION = 280;

export default function useAnimatedModalClose(onClose, options = {}) {
  const { disabled = false, duration = DEFAULT_EXIT_DURATION } = options;
  const [closing, setClosing] = useState(false);
  const timerRef = useRef(null);
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => () => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
  }, []);

  const close = useCallback((event) => {
    event?.stopPropagation?.();
    if (disabled || closing) return Promise.resolve(false);
    setClosing(true);
    return new Promise((resolve) => {
      timerRef.current = window.setTimeout(() => {
        timerRef.current = null;
        setClosing(false);
        onCloseRef.current?.();
        resolve(true);
      }, duration);
    });
  }, [closing, disabled, duration]);

  return {
    closing,
    close,
    modalClassName: `dashboard-modal${closing ? ' is-closing' : ''}`,
  };
}
